// Weekly legendary rolls on boss wins: the first CONFIG.bossLegendary.rollsPerWeek
// wins against each boss in a UTC week (Monday to Sunday, as the crafting bench)
// can bind the boss; later wins pay everything else. Shared by the server, the
// Bosses page and the sim.
import { CONFIG } from './config.ts';
import { weekOf } from './recipes.ts';

/** Chance a boss win also drops a relic. */
export const BOSS_RELIC_CHANCE = 0.35;

export type BossWeek = { week: string; n: Record<string, number> };

/** Legendary rolls used against a boss this week (an old week counts as none). */
export function legendaryRollsUsed(bw: BossWeek | undefined, boss: string, now: number): number {
  return bw && bw.week === weekOf(now) ? bw.n[boss] ?? 0 : 0;
}

/** Legendary rolls left against a boss this week. */
export function legendaryRollsLeft(bw: BossWeek | undefined, boss: string, now: number): number {
  return Math.max(0, CONFIG.bossLegendary.rollsPerWeek - legendaryRollsUsed(bw, boss, now));
}

/** Spend one roll; returns the record to store. */
export function useLegendaryRoll(bw: BossWeek | undefined, boss: string, now: number): BossWeek {
  const week = weekOf(now);
  const out: BossWeek = bw && bw.week === week ? { week, n: { ...bw.n } } : { week, n: {} };
  out.n[boss] = (out.n[boss] ?? 0) + 1;
  return out;
}
